import { useState, useEffect, useContext } from "react";
import { notify, soloNumero } from "../utils/utils";
import { AuthFetch, AuthFetchOauth,Fetch } from "../services/api";
import { useModal } from './useModal';
// import { useModal } from "../useModal";
import { useSpinner } from "./useSpinner";
import { UserContext } from "../context/provider/UserProvider";
// import { isConstructorDeclaration } from "typescript";
// import { useTipoUsuario } from "./useTipoUsuario";


export const useUsuariosPlataforma = () => {
    const { stateUser , signOut } = useContext(UserContext);
    const usuarioDefault = {
        nombreUsuario: '',
        nombreComun: '',
        dni: '',
        nombre: '',
        apellidos:'' ,
        correoElectronico: '',
        telefono: '',
        rol: 0,
        clave:'' 
    }
    
    const [ usuarios, setUsuarios ] = useState([]);
    const [ usuario, setUsuario ] = useState(usuarioDefault);
    const [ spinner, mostrarSpinner, ocultarSpinner ] = useSpinner();
    const [ isOpen, openModal, closeModal ] = useModal();
    const [ isOpenModalEliminar, openModalEliminar, closeModalEliminar ] = useModal()
    const [ spinnerBuscandoDNI, setSpinnerBuscandoDNI ] = useState(false)

    useEffect(() => {
        listarUsuarios();
    }, []);

    const listarUsuarios = async (codEstado) => {
        mostrarSpinner();
        const response = await AuthFetch('/User/listWebUsers?'+ new URLSearchParams({
            codEstado : codEstado ||0 
        }),{
            method: 'GET',
        })


        if (response.isValid) {
            setUsuarios(response.content)
        } else {
        }
        ocultarSpinner()
    }



    const obtenerUsuario = async (uid) => {
        if (uid){
            try{
                const response = await AuthFetch('/User/detail?'+ new URLSearchParams({
                    uid :uid
                }),{
                    method: 'GET',
                })
                !response.isValid && notify(response.exceptions[0].description, 'error') 
                setUsuario(response.isValid ? response.content : usuarioDefault)

            }
            catch(error){
                setUsuario(usuarioDefault);
                console.error('Error → ',error)
            }
        }else{
            // notify('el UID no puedo ser vacío','error')
            setUsuario(usuarioDefault);
        }
        openModal();
    }

    const cargarDatosPorDNI = async () => {
        setSpinnerBuscandoDNI(true)
        const response = await Fetch({url :'https://identidadwebapi.abexacloud.com/api/Identidad/obtenerDni?'+ new URLSearchParams({dni: usuario.dni,}),})
        
        if(response.isValid){
            const usuarioMostrar = {
                codPersona: 0,
                nombre: response.content.nombres,
                apellidos: response.content.apellidoPaterno + ' ' + response.content.apellidoMaterno,
                codDocumentoTipo: 1,
                dni: response.content.dni,

                telefonoActual:'',
                codUsuarioAccion:0,
                codEstado:0,
                motivoEliminacion:'',
                nomEstado:''
            }
            setUsuario(usuarioMostrar)
        }else{
            setUsuario(usuarioDefault)
            notify('Error al traer datos por DNI','error');
        }
        setSpinnerBuscandoDNI(false)
    }

    const usuarioEliminar = async (codUsuario) =>{
        if (codUsuario) {
            const response = await AuthFetch('​/User​/obtenerUsuarioPorCodUsuario?' + new URLSearchParams({
                CodUsuario : codUsuario
            }))
            if (response.isValid) {
                setUsuario(response.content);
            } else {
                notify(response.exceptions[0].description, 'error');
            }
        } else {
            setUsuario(usuarioDefault);
        }
        openModalEliminar();
    }

    const eliminarUsuario = async ()=>{
        const response = await AuthFetchOauth('/api/Manager/eliminarUsuario',{
            method:'POST',
            body: JSON.stringify({
                codUsuario: usuario.codUsuario,
                codUsuarioAccion: 1,
                motivo: usuario.motivo
            })
        })
        notify(response.isValid ? 'Se elimino el usuario Correctamente' : response.exceptions[0].description, response.isValid ? 'success' : 'error')
        if (response.isValid) {
            listarUsuarios()
        }
        closeModalEliminar()
    }

    const guardarEditarUsuario = async () => {
        if ( usuario.claveUsuario === ''){
            notify('Debe ingresar los parametros correctamente','error')
            return;
        } 
        
        const response = await AuthFetch('/registerWebUser', {
            method:'POST', 
            body: JSON.stringify({
                nombreUsuario: usuario.nombreUsuario,
                nombreComun: usuario.nombreComun,
                dni: usuario.dni,
                nombre: usuario.nombre,
                apellidos: usuario.apellidos,
                correoElectronico: usuario.correoElectronico,
                telefono: usuario.telefono,
                rol: [
                    usuario.rol
                ],
                clave: usuario.clave
            })
        });
        notify(response.content,(response.isValid ? 'success' : 'error'));
        if (response.isValid){
            setUsuario(usuarioDefault);
            await listarUsuarios();
        }
        closeModal();
    }
    
    const editarValorUsuario = (key,value) =>{
        setUsuario(usuario => {
            return {
                ...usuario,
                [key]: value
            }
        });
    }     
    return {
        usuarios,
        listarUsuarios,
        usuario,
        editarValorUsuario,
        obtenerUsuario,
        spinner,
        isOpen,
        closeModal,
        isOpenModalEliminar,
        closeModalEliminar,
        guardarEditarUsuario,
        usuarioEliminar,
        eliminarUsuario,
        cargarDatosPorDNI,
        spinnerBuscandoDNI
     };
}